const editor = '[data-editor]'

$(`iframe:not([data-editor-video])`, editor).wrap('<span class="y-iframe y-aspect-ratio" />')
// $('img', editor).wrap('<span class="y-image" />')
// $('li', editor).wrapInner('<span class="li-inner" />')

